import * as React from "react";
import { createStyles, IconButton, makeStyles, Theme, Tooltip } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/HomeOutlined";
import NavigateIcon from "../../assets/icons/NavigateIcon";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "padding": 0,

      "&:hover": {
        "backgroundColor": "inherit",
        "& svg": {
          color: theme.palette.primary.main,
        },
      },
    },

    homeIcon: {
      transform: "rotate(180deg)",
    },
  })
);

function HomeButton() {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push("/home/");
  };

  return (
    <Tooltip title="Clique para ser direcionado de volta à landing page">
      <IconButton className={classes.root} onClick={handleClick}>
        <>
          <NavigateIcon className={classes.homeIcon} />
          <HomeIcon />
        </>
      </IconButton>
    </Tooltip>
  );
}

export default HomeButton;
